/* COLLECTION SORTING */

(function() {

  function initialiseFilters() {
    var wrapper = document.querySelector('[data-filter-wrapper]');
    if (!wrapper) return;

    var section = wrapper.closest('.pp-collection-grid-section');
    if (!section) return;

    var toggle = wrapper.querySelector('[data-filter-toggle]');
    var panel = wrapper.querySelector('[data-filter-panel]');
    var icon = wrapper.querySelector('.pp-filter-toggle__icon');

    var sortToggle = wrapper.querySelector('[data-sort-toggle]');
    var sortPanel = wrapper.querySelector('[data-sort-panel]');
    var sortIcon = wrapper.querySelector('.pp-sort-toggle__icon');

    var checkboxes = wrapper.querySelectorAll('[data-availability-filter]');

    var minSlider = wrapper.querySelector('[data-min-slider]');
    var maxSlider = wrapper.querySelector('[data-max-slider]');

    var minDisplay = wrapper.querySelector('[data-min-price]');
    var maxDisplay = wrapper.querySelector('[data-max-price]');

    var clearButton = wrapper.querySelector('[data-filter-clear]');
    var count = wrapper.querySelector('.pp-filter-count');

    var products = section.querySelectorAll('.pp-product-card');

    var emptyState = section.querySelector('[data-filter-empty]');
    var emptyClearButton = section.querySelector('[data-filter-empty-clear]');


    /* FILTER TOGGLE */

    toggle.addEventListener('click', function() {
      var open = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute(
        'aria-expanded',
        open ? 'false' : 'true'
      );

      panel.hidden = open;
      icon.textContent = open ? '+' : '−';

      section.classList.toggle('pp-filter-open', !open);
    });


    /* SORT TOGGLE */

    sortToggle.addEventListener('click', function() {
      var open = sortToggle.getAttribute('aria-expanded') === 'true';

      sortToggle.setAttribute(
        'aria-expanded',
        open ? 'false' : 'true'
      );

      sortPanel.hidden = open;
      sortIcon.textContent = open ? '+' : '−';
    });


    /* SORTING */

    var sortOptions = wrapper.querySelectorAll('[data-sort-value]');
    var grid = section.querySelector('.pp-collection-grid');

    var newsletterPromo = grid.querySelector('.pp-promo-card--newsletter');
    var irlPromo = grid.querySelector('.pp-promo-card--sale');


    function sortProducts(sortValue) {
      var productArray = Array.prototype.slice.call(products);

      productArray.sort(function(a, b) {

        if (sortValue === 'featured') {
          return (
            parseInt(a.getAttribute('data-product-position'), 10) -
            parseInt(b.getAttribute('data-product-position'), 10)
          );
        }

        if (sortValue === 'newest') {
          return (
            parseInt(b.getAttribute('data-product-created'), 10) -
            parseInt(a.getAttribute('data-product-created'), 10)
          );
        }

        if (sortValue === 'price-ascending') {
          return (
            parseFloat(a.getAttribute('data-product-price')) -
            parseFloat(b.getAttribute('data-product-price'))
          );
        }

        if (sortValue === 'price-descending') {
          return (
            parseFloat(b.getAttribute('data-product-price')) -
            parseFloat(a.getAttribute('data-product-price'))
          );
        }

        if (sortValue === 'title-ascending') {
          return a.getAttribute('data-product-title').localeCompare(
            b.getAttribute('data-product-title')
          );
        }

        if (sortValue === 'title-descending') {
          return b.getAttribute('data-product-title').localeCompare(
            a.getAttribute('data-product-title')
          );
        }

        return 0;
      });


      productArray.forEach(function(product) {
        product.classList.add('pp-sorting');
      });


      setTimeout(function() {

        productArray.forEach(function(product, index) {

          grid.appendChild(product);

          if (index === 3 && newsletterPromo) {
            grid.appendChild(newsletterPromo);
          }

          if (index === 7 && irlPromo) {
            grid.appendChild(irlPromo);
          }

        });


        requestAnimationFrame(function() {

          productArray.forEach(function(product) {
            product.classList.remove('pp-sorting');
          });

        });

      }, 180);
    }


    sortOptions.forEach(function(option) {

      option.addEventListener('click', function() {

        var sortValue = option.getAttribute('data-sort-value');

        sortProducts(sortValue);

        sortToggle.setAttribute('aria-expanded', 'false');
        sortPanel.hidden = true;
        sortIcon.textContent = '+';

      });

    });


    /* PRICE DISPLAY */

    function updatePriceText() {

      var min = parseInt(minSlider.value, 10);
      var max = parseInt(maxSlider.value, 10);

      minDisplay.textContent = '£' + min;

      maxDisplay.textContent =
        max >= 100
          ? '£100+'
          : '£' + max;

    }


    /* FILTER PRODUCTS */

    function filterProducts() {

      var selected = [];

      checkboxes.forEach(function(checkbox) {

        if (checkbox.checked) {
          selected.push(checkbox.value);
        }

      });


      var min = parseFloat(minSlider.value);
      var max = parseFloat(maxSlider.value);

      var visible = 0;


      products.forEach(function(product) {

        var available =
          product.getAttribute('data-product-available') === 'true';

        var price = parseFloat(
          product.getAttribute('data-product-price')
        );


        var availabilityOK = true;


        if (selected.length) {

          availabilityOK = false;

          if (
            available &&
            selected.indexOf('available') !== -1
          ) {
            availabilityOK = true;
          }

          if (
            !available &&
            selected.indexOf('soldout') !== -1
          ) {
            availabilityOK = true;
          }

        }


        var priceOK;


        if (max >= 100) {

          priceOK = price >= min;

        } else {

          priceOK =
            price >= min &&
            price <= max;

        }


        if (availabilityOK && priceOK) {

          product.style.display = '';
          visible++;

        } else {

          product.style.display = 'none';

        }

      });


      count.textContent =
        visible +
        (visible === 1 ? ' PRODUCT' : ' PRODUCTS');


      if (emptyState) {

        emptyState.style.display =
          visible === 0 ? 'block' : 'none';

      }

    }


    checkboxes.forEach(function(checkbox) {

      checkbox.addEventListener(
        'change',
        filterProducts
      );

    });


    /* MIN PRICE */

    minSlider.addEventListener('input', function() {

      if (
        parseInt(minSlider.value, 10) >
        parseInt(maxSlider.value, 10)
      ) {
        minSlider.value = maxSlider.value;
      }

      updatePriceText();
      filterProducts();

    });


    /* MAX PRICE */

    maxSlider.addEventListener('input', function() {

      if (
        parseInt(maxSlider.value, 10) <
        parseInt(minSlider.value, 10)
      ) {
        maxSlider.value = minSlider.value;
      }

      updatePriceText();
      filterProducts();

    });


    /* CLEAR FILTERS */

    function clearFilters() {

      checkboxes.forEach(function(checkbox) {
        checkbox.checked = false;
      });

      minSlider.value = 0;
      maxSlider.value = 100;

      updatePriceText();
      filterProducts();

    }


    clearButton.addEventListener(
      'click',
      clearFilters
    );


    if (emptyClearButton) {

      emptyClearButton.addEventListener(
        'click',
        clearFilters
      );

    }


    updatePriceText();

  }


  /* =========================================
     SEARCH
  ========================================= */

function initialiseSearch() {

  var searchPage = document.querySelector('.pp-search-page');

  if (!searchPage) return;


  /* SEARCH ELEMENTS */

  var filterToggle =
    searchPage.querySelector('[data-search-filter-toggle]');

  var filterPanel =
    searchPage.querySelector('[data-search-filter-panel]');

  var filterIcon =
    searchPage.querySelector('.pp-search-filter__icon');

  var sortToggle =
    searchPage.querySelector('[data-search-sort-toggle]');

  var sortPanel =
    searchPage.querySelector('[data-search-sort-panel]');

  var sortIcon =
    searchPage.querySelector('.pp-search-sort__icon');

  var checkboxes =
    searchPage.querySelectorAll(
      '[data-search-availability-filter]'
    );

  var minSlider =
    searchPage.querySelector('[data-search-min-slider]');

  var maxSlider =
    searchPage.querySelector('[data-search-max-slider]');

  var minDisplay =
    searchPage.querySelector('[data-search-min-price]');

  var maxDisplay =
    searchPage.querySelector('[data-search-max-price]');

  var clearButton =
    searchPage.querySelector('[data-search-filter-clear]');

  var emptyClearButton =
    searchPage.querySelector(
      '[data-search-filter-empty-clear]'
    );

  var count =
    searchPage.querySelector('.pp-search-count');

  var grid =
    searchPage.querySelector('.pp-search-grid');

  var products =
    searchPage.querySelectorAll('.pp-product-card');

  var emptyState =
    searchPage.querySelector('[data-search-filter-empty]');


  /* FILTER TOGGLE */

  if (filterToggle && filterPanel) {

    filterToggle.addEventListener('click', function() {

      var open =
        filterToggle.getAttribute('aria-expanded') === 'true';

      filterToggle.setAttribute(
        'aria-expanded',
        open ? 'false' : 'true'
      );

      filterPanel.hidden = open;

      if (filterIcon) {
        filterIcon.textContent =
          open ? '+' : '−';
      }

    });

  }


  /* SORT TOGGLE */

  if (sortToggle && sortPanel) {

    sortToggle.addEventListener('click', function() {

      var open =
        sortToggle.getAttribute('aria-expanded') === 'true';

      sortToggle.setAttribute(
        'aria-expanded',
        open ? 'false' : 'true'
      );

      sortPanel.hidden = open;

      if (sortIcon) {
        sortIcon.textContent =
          open ? '+' : '−';
      }

    });

  }


  /* PRICE DISPLAY */

  function updatePriceText() {

    if (!minSlider || !maxSlider) return;

    var min =
      parseInt(minSlider.value, 10);

    var max =
      parseInt(maxSlider.value, 10);

    if (minDisplay) {
      minDisplay.textContent =
        '£' + min;
    }

    if (maxDisplay) {
      maxDisplay.textContent =
        max >= 100
          ? '£100+'
          : '£' + max;
    }

  }


  /* FILTER PRODUCTS */

  function filterProducts() {

    if (!products.length) return;

    var selected = [];


    checkboxes.forEach(function(checkbox) {

      if (checkbox.checked) {
        selected.push(checkbox.value);
      }

    });


    var min =
      minSlider
        ? parseFloat(minSlider.value)
        : 0;

    var max =
      maxSlider
        ? parseFloat(maxSlider.value)
        : 100;


    var visible = 0;


    products.forEach(function(product) {

      var available =
        product.getAttribute(
          'data-product-available'
        ) === 'true';


      var price =
        parseFloat(
          product.getAttribute(
            'data-product-price'
          )
        );


      /* AVAILABILITY */

      var availabilityOK = true;


      if (selected.length) {

        availabilityOK = false;


        if (
          available &&
          selected.indexOf('available') !== -1
        ) {
          availabilityOK = true;
        }


        if (
          !available &&
          selected.indexOf('soldout') !== -1
        ) {
          availabilityOK = true;
        }

      }


      /* PRICE */

      var priceOK;


      if (max >= 100) {

        priceOK =
          price >= min;

      } else {

        priceOK =
          price >= min &&
          price <= max;

      }


      /* SHOW / HIDE */

      if (
        availabilityOK &&
        priceOK
      ) {

        product.style.display = '';
        visible++;

      } else {

        product.style.display = 'none';

      }

    });


    /* UPDATE COUNT */

    if (count) {

      count.textContent =
        visible +
        (visible === 1
          ? ' RESULT'
          : ' RESULTS');

    }


    /* EMPTY STATE */

    if (emptyState) {

      emptyState.style.display =
        visible === 0
          ? 'block'
          : 'none';

    }

  }


  /* AVAILABILITY */

  checkboxes.forEach(function(checkbox) {

    checkbox.addEventListener(
      'change',
      filterProducts
    );

  });


  /* MIN PRICE */

  if (minSlider) {

    minSlider.addEventListener(
      'input',
      function() {

        if (
          parseInt(minSlider.value, 10) >
          parseInt(maxSlider.value, 10)
        ) {
          minSlider.value =
            maxSlider.value;
        }

        updatePriceText();
        filterProducts();

      }
    );

  }


  /* MAX PRICE */

  if (maxSlider) {

    maxSlider.addEventListener(
      'input',
      function() {

        if (
          parseInt(maxSlider.value, 10) <
          parseInt(minSlider.value, 10)
        ) {
          maxSlider.value =
            minSlider.value;
        }

        updatePriceText();
        filterProducts();

      }
    );

  }


  /* CLEAR FILTERS */

  function clearFilters() {

    checkboxes.forEach(function(checkbox) {
      checkbox.checked = false;
    });


    if (minSlider) {
      minSlider.value = 0;
    }


    if (maxSlider) {
      maxSlider.value = 100;
    }


    updatePriceText();
    filterProducts();

  }


  if (clearButton) {

    clearButton.addEventListener(
      'click',
      clearFilters
    );

  }


  if (emptyClearButton) {

    emptyClearButton.addEventListener(
      'click',
      clearFilters
    );

  }


  updatePriceText();


  /* =========================================
     SEARCH SORTING
  ========================================= */

  var sortOptions =
    searchPage.querySelectorAll(
      '[data-search-sort-value]'
    );


  function sortProducts(sortValue) {

    if (!grid || !products.length) return;


    var productArray =
      Array.prototype.slice.call(products);


    productArray.sort(function(a, b) {

      if (sortValue === 'featured') {

        return (
          parseInt(
            a.getAttribute(
              'data-product-position'
            ),
            10
          ) -
          parseInt(
            b.getAttribute(
              'data-product-position'
            ),
            10
          )
        );

      }


      if (sortValue === 'newest') {

        return (
          parseInt(
            b.getAttribute(
              'data-product-created'
            ),
            10
          ) -
          parseInt(
            a.getAttribute(
              'data-product-created'
            ),
            10
          )
        );

      }


      if (sortValue === 'price-ascending') {

        return (
          parseFloat(
            a.getAttribute(
              'data-product-price'
            )
          ) -
          parseFloat(
            b.getAttribute(
              'data-product-price'
            )
          )
        );

      }


      if (sortValue === 'price-descending') {

        return (
          parseFloat(
            b.getAttribute(
              'data-product-price'
            )
          ) -
          parseFloat(
            a.getAttribute(
              'data-product-price'
            )
          )
        );

      }


      if (sortValue === 'title-ascending') {

        return a
          .getAttribute('data-product-title')
          .localeCompare(
            b.getAttribute(
              'data-product-title'
            )
          );

      }


      if (sortValue === 'title-descending') {

        return b
          .getAttribute('data-product-title')
          .localeCompare(
            a.getAttribute(
              'data-product-title'
            )
          );

      }


      return 0;

    });


    productArray.forEach(function(product) {

      product.classList.add(
        'pp-sorting'
      );

    });


    setTimeout(function() {

      productArray.forEach(function(product) {

        grid.appendChild(product);

      });


      requestAnimationFrame(function() {

        productArray.forEach(function(product) {

          product.classList.remove(
            'pp-sorting'
          );

        });

      });

    }, 180);

  }


  sortOptions.forEach(function(option) {

    option.addEventListener(
      'click',
      function() {

        var sortValue =
          option.getAttribute(
            'data-search-sort-value'
          );


        sortProducts(sortValue);


        if (sortToggle) {

          sortToggle.setAttribute(
            'aria-expanded',
            'false'
          );

        }


        if (sortPanel) {
          sortPanel.hidden = true;
        }


        if (sortIcon) {
          sortIcon.textContent = '+';
        }

      }
    );

  });

}


  function initialise() {

    initialiseFilters();
    initialiseSearch();

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();

  }

})();


/* BASKET NUMBER */

async function updateBasketCount() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const basketCount = document.getElementById('basket-count');

        if (basketCount) {
            basketCount.textContent = cart.item_count;
        }

    } catch (error) {
        console.error('Unable to update basket count:', error);
    }
}

updateBasketCount();



/* homepage - product carousels */

(function () {

  function initProductCarousels() {

    const carousels = document.querySelectorAll(
      '[data-product-carousel]'
    );

    if (!carousels.length) return;


    carousels.forEach(function (carousel) {

      const section = carousel.closest(
        '.best-sellers, .homepage-new-in'
      );

      if (!section) return;


      const cards = carousel.querySelectorAll(
        '.best-seller-card, .homepage-new-in-card'
      );

      if (!cards.length) return;


      const previousButton = section.querySelector(
        '[data-product-carousel-prev]'
      );

      const nextButton = section.querySelector(
        '[data-product-carousel-next]'
      );


      function moveCarousel(direction) {

        const card = cards[0];

        const cardWidth =
          card.getBoundingClientRect().width;

        const gap =
          parseFloat(
            window.getComputedStyle(carousel).columnGap
          ) || 20;

        const amount =
          (cardWidth + gap) * 2;

        carousel.scrollBy({
          left: direction * amount,
          behavior: 'smooth'
        });

      }


      if (previousButton) {

        previousButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            moveCarousel(-1);

          }
        );

      }


      if (nextButton) {

        nextButton.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            moveCarousel(1);

          }
        );

      }


      function positionArrows() {

        const wrapper =
          carousel.parentElement;

        const image =
          section.querySelector(
            '.best-seller-card__image, .homepage-new-in-card__image'
          );

        if (!wrapper || !image) return;


        const wrapperRect =
          wrapper.getBoundingClientRect();

        const imageRect =
          image.getBoundingClientRect();


        const imageCentre =
          (imageRect.top - wrapperRect.top) +
          (imageRect.height / 2);


        if (previousButton) {

          previousButton.style.top =
            imageCentre + 'px';

        }


        if (nextButton) {

          nextButton.style.top =
            imageCentre + 'px';

        }

      }


      positionArrows();


      window.addEventListener(
        'resize',
        positionArrows
      );

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initProductCarousels
    );

  } else {

    initProductCarousels();

  }

})();


/* mobile dropdown */

const accordions = document.querySelectorAll('.footer-dropdown');

accordions.forEach((accordion)=>{

    const button = accordion.querySelector('.dropdown-toggle');
    const content = accordion.querySelector('.dropdown-content');

    button.addEventListener('click',()=>{

        const isOpen = accordion.classList.contains('active');

        accordions.forEach(item=>{

            if(item!==accordion){

                item.classList.remove('active');

                item.querySelector('.dropdown-content').style.height = 0;

            }

        });

        if(isOpen){

            accordion.classList.remove('active');

            content.style.height = 0;

        }else{

            accordion.classList.add('active');

            content.style.height = content.scrollHeight + "px";

        }

    });

});


/* DROP DOWN MENU */

document.addEventListener('DOMContentLoaded', function () {

  const burger = document.querySelector('[data-pp-burger]');
  const menu = document.querySelector('[data-pp-mobile-menu]');
  const closeButton = document.querySelector('.pp-mobile-menu__close');

  if (!burger || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');

    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');

    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.remove('is-open');

    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');

    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {

    if (menu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }

  });

  if (closeButton) {

    closeButton.addEventListener('click', function () {
      closeMenu();
    });

  }

  const dropdownButtons = document.querySelectorAll(
    '[data-mobile-dropdown]'
  );

  dropdownButtons.forEach(function (button) {

    button.addEventListener('click', function () {

      const name = button.getAttribute('data-mobile-dropdown');

      const submenu = document.querySelector(
        '[data-mobile-submenu="' + name + '"]'
      );

      if (!submenu) return;


      const wasOpen = submenu.classList.contains('is-open');


      /* Close every submenu */

      document.querySelectorAll('.pp-mobile-submenu').forEach(function (item) {
        item.classList.remove('is-open');
      });

      document.querySelectorAll('.pp-mobile-menu__link--dropdown').forEach(function (item) {
        item.classList.remove('is-open');
        item.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {

        submenu.classList.add('is-open');

        button.classList.add('is-open');

        button.setAttribute('aria-expanded', 'true');

      }

    });

  });

});


/* BURGER MENU */

document.querySelectorAll('.pp-nav-item--dropdown').forEach(function(navItem) {

  const className = [...navItem.classList]
    .find(className => className.startsWith('pp-nav-item--') && className !== 'pp-nav-item--dropdown');

  if (!className) return;

  const dropdownName = className.replace('pp-nav-item--', '');
  const dropdown = document.querySelector('.pp-dropdown--' + dropdownName);

  if (!dropdown) return;

  function activate() {
    navItem.classList.add('is-active');
  }

  function deactivate() {
    setTimeout(function() {
      if (!navItem.matches(':hover') && !dropdown.matches(':hover')) {
        navItem.classList.remove('is-active');
      }
    }, 50);
  }

  navItem.addEventListener('mouseenter', activate);
  navItem.addEventListener('mouseleave', deactivate);

  dropdown.addEventListener('mouseenter', activate);
  dropdown.addEventListener('mouseleave', deactivate);
});


//PRODUCT PAGE


(() => {
  const root = document.querySelector('.pp-product');

  if (!root) {
    console.error('Peachpuff product section not found');
    return;
  }

  // Prevent duplicate listeners if Shopify evaluates this script again.
  if (root.dataset.ppJsInitialized === 'true') return;
  root.dataset.ppJsInitialized = 'true';

  // PRODUCT GALLERY
  const gallery = root.querySelector('[data-pp-gallery]');

  if (gallery) {
    const mainImage = gallery.querySelector('.pp-gallery__image');
    const thumbs = Array.from(
      gallery.querySelectorAll('.pp-gallery__thumb')
    );
    const prev = gallery.querySelector('.pp-gallery__arrow--prev');
    const next = gallery.querySelector('.pp-gallery__arrow--next');

    let currentIndex = Math.max(
      0,
      thumbs.findIndex((thumb) =>
        thumb.classList.contains('is-selected')
      )
    );

    function showImage(index) {
      if (!mainImage || !thumbs.length) return;

      currentIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];
      const imageUrl = thumb.dataset.image;

      if (imageUrl) {
        mainImage.setAttribute('src', imageUrl);
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.alt = thumb.dataset.alt || '';
      }

      thumbs.forEach((button, i) => {
        const selected = i === currentIndex;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showImage(index));
    });

    prev?.addEventListener('click', () => showImage(currentIndex - 1));
    next?.addEventListener('click', () => showImage(currentIndex + 1));
  }

  // VARIANT PRICE AND AVAILABILITY
  const variant = root.querySelector('select[name="id"]');
  const prices = root.querySelectorAll('.pp-price');
  const addButton = root.querySelector('.pp-add');

  variant?.addEventListener('change', () => {
    const option = variant.selectedOptions[0];
    if (!option) return;

    if (option.dataset.price) {
      const unitPrice = Number(option.dataset.price);

      if (Number.isFinite(unitPrice)) {
        const formattedPrice = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        }).format(unitPrice / 100);

        prices.forEach((priceElement) => {
          priceElement.dataset.price = String(unitPrice);
          priceElement.textContent = formattedPrice;
        });
      }
    }

    if (addButton) {
      addButton.disabled = option.disabled;
    }

    requestAnimationFrame(() => {
      updateQuantityLimit();
    });
  });

  // FABRIC SWATCHES
  root.querySelectorAll('.pp-fabric-picker').forEach((picker) => {
    const variantSelect = picker.querySelector('.pp-variant-select');
    const swatches = picker.querySelectorAll('.pp-fabric-swatch');
    const selectedName = picker.querySelector('.pp-fabric-selected span');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const variantId = swatch.dataset.variantId;

        if (!variantSelect || !variantId || swatch.disabled) return;

        variantSelect.value = variantId;
        variantSelect.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        swatches.forEach((button) => {
          const selected = button === swatch;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });

        if (selectedName) {
          selectedName.textContent = swatch.title || '';
        }

        const imageUrl = swatch.dataset.variantImage;
        const mainImage = root.querySelector('.pp-gallery__image');

        if (imageUrl && mainImage) {
          mainImage.src = imageUrl;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }

        requestAnimationFrame(() => {
          updateQuantityLimit();
        });
      });
    });
  });

  // QUANTITY + ADD TO BAG TOTAL
  const quantityInput = root.querySelector('input[name="quantity"]');
  const minusButton = root.querySelector('[data-quantity-minus]');
  const plusButton = root.querySelector('[data-quantity-plus]');
  const addButtonText = root.querySelector('#AddToCartText');
  const variantSelect = root.querySelector('.pp-variant-select');

  function getSelectedStock() {
    const selectedSwatch = root.querySelector(
      '.pp-fabric-swatch.is-selected'
    );

    if (!selectedSwatch) {
      return { tracked: false, stock: Infinity };
    }

    const tracked =
      selectedSwatch.dataset.inventoryTracked === 'true';
    const stock = Number(selectedSwatch.dataset.variantInventory);

    return {
      tracked,
      stock: tracked ? Math.max(0, stock) : Infinity
    };
  }

  function updateQuantityLimit() {
    if (!quantityInput) return;

    const { tracked, stock } = getSelectedStock();

    if (tracked) {
      quantityInput.max = stock;
      quantityInput.value = Math.min(
        Math.max(1, parseInt(quantityInput.value, 10) || 1),
        stock
      );
    } else {
      quantityInput.removeAttribute('max');
      quantityInput.value = Math.max(
        1,
        parseInt(quantityInput.value, 10) || 1
      );
    }

    updateAddButtonTotal();
  }

  function updateAddButtonTotal() {
    if (!quantityInput || !addButtonText) return;

    const selectedOption = variantSelect?.selectedOptions?.[0];
    const selectedVariantId = selectedOption?.value;

    const selectedSwatch = selectedVariantId
      ? root.querySelector(
          `.pp-fabric-swatch[data-variant-id="${selectedVariantId}"]`
        )
      : root.querySelector('.pp-fabric-swatch.is-selected');

    const soldOut =
      selectedOption?.disabled ||
      selectedSwatch?.dataset.available === 'false';

    if (soldOut) {
      addButtonText.textContent = 'SOLD OUT';
      if (addButton) addButton.disabled = true;
      return;
    }

    if (addButton) addButton.disabled = false;

    const rawPrice =
      selectedOption?.dataset.price ||
      selectedSwatch?.dataset.variantPrice;

    if (rawPrice === undefined || rawPrice === null || rawPrice === '') {
      return;
    }

    const price = Number(rawPrice);
    if (!Number.isFinite(price)) return;

    const quantity = Math.max(
      1,
      parseInt(quantityInput.value, 10) || 1
    );

    const formattedTotal = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((price * quantity) / 100);

    addButtonText.textContent = `ADD TO BAG • ${formattedTotal}`;
  }

  minusButton?.addEventListener('click', () => {
    if (!quantityInput) return;

    const current = parseInt(quantityInput.value, 10) || 1;

    if (current > 1) {
      quantityInput.value = current - 1;
    }

    updateQuantityLimit();
  });

  plusButton?.addEventListener('click', () => {
    if (!quantityInput) return;

    const { tracked, stock } = getSelectedStock();
    const current = parseInt(quantityInput.value, 10) || 1;

    if (!tracked || current < stock) {
      quantityInput.value = current + 1;
    }

    updateQuantityLimit();
  });

  quantityInput?.addEventListener('input', updateAddButtonTotal);
  quantityInput?.addEventListener('change', updateAddButtonTotal);

  root.querySelectorAll('.pp-fabric-swatch').forEach((swatch) => {
    swatch.addEventListener('click', () => {
      requestAnimationFrame(updateQuantityLimit);
    });
  });

  variantSelect?.addEventListener('change', updateQuantityLimit);

  updateQuantityLimit();



  // CLICK-TO-ZOOM LIGHTBOX
  const lightbox = root.querySelector('[data-pp-lightbox]');
  const zoomOpen = root.querySelector('[data-pp-zoom-open]');
  const zoomClose = root.querySelector('[data-pp-zoom-close]');
  const zoomImage = root.querySelector('[data-pp-zoom-image]');
  const zoomPrev = root.querySelector('[data-pp-zoom-prev]');
  const zoomNext = root.querySelector('[data-pp-zoom-next]');

  const zoomThumbnails = Array.from(
    root.querySelectorAll('.pp-gallery__lightbox-thumb')
  );

  let panX = 0;
  let panY = 0;
  let dragStartX = 0;
  let dragStartY = 0;
  let startPanX = 0;
  let startPanY = 0;
  let isDragging = false;
  let didDrag = false;

  const activePointers = new Map();
  let pinchStartDistance = 0;
  let pinchStartScale = 0;
  let pinchBaseScale = 0;
  let isPinching = false;

  function getZoomScale() {
    const stage = zoomImage?.closest(
      '.pp-gallery__lightbox-stage'
    );

    if (!stage || !zoomImage) return 2;

    const imageWidth = zoomImage.offsetWidth;
    const imageHeight = zoomImage.offsetHeight;

    if (!imageWidth || !imageHeight) return 2;

    return Math.max(
      1.5,
      stage.clientWidth / imageWidth,
      stage.clientHeight / imageHeight
    );
  }

  function resetPan() {
    panX = 0;
    panY = 0;

    zoomImage?.style.setProperty('--pan-x', '0px');
    zoomImage?.style.setProperty('--pan-y', '0px');
    zoomImage?.style.removeProperty('--zoom-scale');
    zoomImage?.classList.remove('is-dragging');
  }

  function selectZoomThumbnail(thumb) {
    if (!thumb || !zoomImage) return;

    const imageUrl = thumb.dataset.zoomImage;
    if (!imageUrl) return;

    zoomImage.src = imageUrl;
    zoomImage.alt = thumb.dataset.zoomAlt || '';

    zoomImage.classList.remove('is-zoomed');
    resetPan();

    zoomThumbnails.forEach((button) => {
      const selected = button === thumb;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    const imageId = thumb.dataset.zoomImageId;

    if (imageId) {
      const matchingGalleryThumb = root.querySelector(
        `.pp-gallery__thumb[data-image-id="${imageId}"]`
      );

      matchingGalleryThumb?.click();
    }
  }

  zoomThumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      selectZoomThumbnail(thumb);
    });
  });

  // CLICK TO ZOOM
  zoomImage?.addEventListener('click', (event) => {
    if (didDrag) {
      didDrag = false;
      event.preventDefault();
      return;
    }

    if (zoomImage.classList.contains('is-zoomed')) {
      zoomImage.classList.remove('is-zoomed');
      resetPan();
    } else {
      resetPan();

      zoomImage.style.setProperty(
        '--zoom-scale',
        String(getZoomScale())
      );

      zoomImage.classList.add('is-zoomed');
    }
  });

  zoomImage?.addEventListener('dragstart', (event) => {
    event.preventDefault();
  });

  function getPointerDistance() {
    const points = Array.from(activePointers.values());

    if (points.length < 2) return 0;

    return Math.hypot(
      points[0].x - points[1].x,
      points[0].y - points[1].y
    );
  }

  // START DRAGGING OR PINCHING
  zoomImage?.addEventListener('pointerdown', (event) => {
    activePointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY
    });

    if (activePointers.size === 2) {
      isPinching = true;
      isDragging = false;
      didDrag = true;

      if (!zoomImage.classList.contains('is-zoomed')) {
        pinchBaseScale = getZoomScale();
        resetPan();

        zoomImage.style.setProperty(
          '--zoom-scale',
          String(pinchBaseScale)
        );

        zoomImage.classList.add('is-zoomed');
      }

      pinchStartDistance = getPointerDistance();

      pinchStartScale =
        Number(
          zoomImage.style.getPropertyValue('--zoom-scale')
        ) || getZoomScale();

      event.preventDefault();
      return;
    }

    if (activePointers.size > 2) return;

    if (zoomImage.classList.contains('is-zoomed')) {
      isDragging = true;
      didDrag = false;

      dragStartX = event.clientX;
      dragStartY = event.clientY;
      startPanX = panX;
      startPanY = panY;

      zoomImage.classList.add('is-dragging');
    }
  });

  // MOVE POINTERS
  zoomImage?.addEventListener('pointermove', (event) => {
    if (!activePointers.has(event.pointerId)) return;

    activePointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY
    });

    if (activePointers.size >= 2 && isPinching) {
      const distance = getPointerDistance();
      if (!pinchStartDistance) return;

      const minScale = 1;
      const maxScale = Math.max(3, pinchBaseScale * 3);

      const nextScale = Math.max(
        minScale,
        Math.min(
          maxScale,
          pinchStartScale * distance / pinchStartDistance
        )
      );

      zoomImage.style.setProperty(
        '--zoom-scale',
        String(nextScale)
      );

      const stage = zoomImage.closest(
        '.pp-gallery__lightbox-stage'
      );

      if (stage) {
        const maxX = Math.max(
          0,
          (zoomImage.offsetWidth * nextScale -
            stage.clientWidth) / 2
        );

        const maxY = Math.max(
          0,
          (zoomImage.offsetHeight * nextScale -
            stage.clientHeight) / 2
        );

        panX = Math.max(-maxX, Math.min(maxX, panX));
        panY = Math.max(-maxY, Math.min(maxY, panY));

        zoomImage.style.setProperty('--pan-x', `${panX}px`);
        zoomImage.style.setProperty('--pan-y', `${panY}px`);
      }

      didDrag = true;
      event.preventDefault();
      return;
    }

    if (!isDragging || activePointers.size !== 1) return;

    const dx = event.clientX - dragStartX;
    const dy = event.clientY - dragStartY;

    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
      didDrag = true;
    }

    const stage = zoomImage.closest(
      '.pp-gallery__lightbox-stage'
    );

    if (!stage) return;

    const scale =
      Number(
        zoomImage.style.getPropertyValue('--zoom-scale')
      ) || getZoomScale();

    const maxX = Math.max(
      0,
      (zoomImage.offsetWidth * scale -
        stage.clientWidth) / 2
    );

    const maxY = Math.max(
      0,
      (zoomImage.offsetHeight * scale -
        stage.clientHeight) / 2
    );

    panX = Math.max(-maxX, Math.min(maxX, startPanX + dx));
    panY = Math.max(-maxY, Math.min(maxY, startPanY + dy));

    zoomImage.style.setProperty('--pan-x', `${panX}px`);
    zoomImage.style.setProperty('--pan-y', `${panY}px`);
  });

  function finishPointer(event) {
    activePointers.delete(event.pointerId);

    if (isPinching) {
      isPinching = false;
      isDragging = false;
      zoomImage?.classList.remove('is-dragging');
      didDrag = true;
      return;
    }

    isDragging = false;
    zoomImage?.classList.remove('is-dragging');
  }

  zoomImage?.addEventListener('pointerup', finishPointer);
  zoomImage?.addEventListener('pointercancel', finishPointer);

  // OPEN AND CLOSE LIGHTBOX
  function openZoom() {
    if (!lightbox || !zoomImage) return;

    const selectedThumb = root.querySelector(
      '.pp-gallery__thumb.is-selected'
    );
    const mainImage = root.querySelector('.pp-gallery__image');

    zoomImage.src =
      selectedThumb?.dataset.image ||
      mainImage?.currentSrc ||
      mainImage?.src ||
      '';

    zoomImage.alt =
      selectedThumb?.dataset.alt ||
      mainImage?.alt ||
      '';

    zoomImage.classList.remove('is-zoomed');
    resetPan();

    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    zoomClose?.focus();
  }

  function closeZoom() {
    if (!lightbox) return;

    lightbox.hidden = true;
    document.body.style.overflow = '';

    activePointers.clear();
    isDragging = false;
    isPinching = false;
    didDrag = false;

    zoomImage?.classList.remove('is-zoomed');
    resetPan();

    zoomOpen?.focus();
  }

  function changeZoomImage(direction) {
    const thumbs = Array.from(
      root.querySelectorAll('.pp-gallery__thumb')
    );

    if (!thumbs.length || !zoomImage) return;

    const selectedIndex = thumbs.findIndex((thumb) =>
      thumb.classList.contains('is-selected')
    );

    const currentIndex = selectedIndex >= 0 ? selectedIndex : 0;
    const nextIndex =
      (currentIndex + direction + thumbs.length) % thumbs.length;

    const thumb = thumbs[nextIndex];

    zoomImage.src =
      thumb.dataset.image || zoomImage.src;

    zoomImage.alt = thumb.dataset.alt || '';
    zoomImage.classList.remove('is-zoomed');
    resetPan();

    const imageId = thumb.dataset.imageId;

    const matchingZoomThumb = zoomThumbnails.find(
      (button) => button.dataset.zoomImageId === imageId
    );

    if (matchingZoomThumb) {
      zoomThumbnails.forEach((button) => {
        const selected = button === matchingZoomThumb;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    thumb.click();
  }

  zoomOpen?.addEventListener('click', openZoom);
  zoomClose?.addEventListener('click', closeZoom);

  zoomPrev?.addEventListener('click', () => {
    changeZoomImage(-1);
  });

  zoomNext?.addEventListener('click', () => {
    changeZoomImage(1);
  });

  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeZoom();
  });

  document.addEventListener('keydown', (event) => {
    if (!lightbox || lightbox.hidden) return;

    if (event.key === 'Escape') closeZoom();
    if (event.key === 'ArrowLeft') changeZoomImage(-1);
    if (event.key === 'ArrowRight') changeZoomImage(1);
  });



  // PRODUCT ACCORDIONS
  root.querySelectorAll('.product-accordion').forEach((accordion) => {
    const button = accordion.querySelector(
      '.product-accordion__summary'
    );
    const content = accordion.querySelector(
      '.product-accordion__content'
    );

    if (!button || !content) return;

    const isOpen = accordion.classList.contains('open');

    button.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      content.style.height = 'auto';
    } else {
      content.style.height = '0px';
    }

    button.addEventListener('click', () => {
      const currentlyOpen = accordion.classList.contains('open');

      if (currentlyOpen) {
        content.style.height = `${content.scrollHeight}px`;

        requestAnimationFrame(() => {
          content.style.height = '0px';
        });

        accordion.classList.remove('open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('open');
        button.setAttribute('aria-expanded', 'true');

        content.style.height = `${content.scrollHeight}px`;

        const handleTransitionEnd = (event) => {
          if (
            event.target !== content ||
            event.propertyName !== 'height'
          ) {
            return;
          }

          content.removeEventListener(
            'transitionend',
            handleTransitionEnd
          );

          if (accordion.classList.contains('open')) {
            content.style.height = 'auto';
          }
        };

        content.addEventListener(
          'transitionend',
          handleTransitionEnd
        );
      }
    });
  });
})();